import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Map, Marker, MarkerLayer, MouseControl, CompassControl, KeyboardControl } from 'react-mapycz';

import Header from '../components/Header/Header';
import SideBar from '../components/SideBar/SideBar';
import IntervalsContent from '../components/IntervalsContent/IntervalsContent';
import { getCommonData } from '../components/Main/actions';
import { getDays, getIntervals, getOfficeInfo, getServiceInfo, serviceSelectDay, } from '../components/IntervalsContent/actions';
import { getOfficeStatsMonth, getOfficeStatsYear, officeSelectDay, officeStatsChangeDate } from '../components/OfficeStats/actions';
import OfficeStats from '../components/OfficeStats/OfficeStats';


class IntervalsPage extends Component {
  constructor(props) {
    super(props);

    const { officeId , serviceId, } = this.props.params;

    this.state = {
      officeId: officeId,
      serviceId: serviceId,
    };

    this.handleOnClickDay = this.handleOnClickDay.bind(this);
    this.onClickTableRow = this.onClickTableRow.bind(this);
    this.handleMonthChange = this.handleMonthChange.bind(this);
  }

  componentDidMount() {
    document.title = 'Výběr termínu';

    if (this.props.intervalsCommon.status === false) 
      this.props.getCommonData();

    const { officeId , serviceId, } = this.state;
    this.props.getDays(officeId, serviceId);
    this.props.getOfficeInfo(officeId);
    this.props.getServiceInfo(officeId, serviceId);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.daysData.data.length === 0
        && this.props.daysData.data.length !== 0
        && this.props.serviceState.selectedDateId !== '') {
          
      const { data } = this.props.daysData;
      for (var i = 0; i < data.length; i++) {
     
        if (data[i].id === this.props.serviceState.selectedDateId
            && data[i].type === 'free') {
          this.props.getIntervals(this.props.serviceState.selectedDateId);
        }            
      }
    }
  }

  handleOnClickDay(dayId, day) {
    this.props.serviceSelectDay(day, dayId);

    this.props.getIntervals(dayId);

    const tmpDay = new Date(day);
    const tmpDayNum = tmpDay.getDay();
    this.props.officeSelectDay(tmpDayNum === 0 ? 6 : tmpDayNum - 1, tmpDay.getMonth(), tmpDay.getFullYear());
  }

  handleMonthChange(date) {
    const { year, month, dateChecked, } = this.props.officeStats
    const { officeId, serviceId, } = this.state;
    const dateFormat = new Date(date)
    const newMonth = dateFormat.getMonth();
    const newYear = dateFormat.getFullYear();

    if (dateChecked === 'month' && ( newMonth !== month || newYear !== year )) {
      this.props.getOfficeStatsMonth(officeId, serviceId, newYear, newMonth);
    }
    else if (dateChecked === 'year' && newYear !== year) {
      this.props.getOfficeStatsYear(officeId, serviceId, newYear, newMonth);
    }
    else {
      this.props.officeStatsChangeDate(newYear, newMonth);
    }
  }

  onClickTableRow(intervalId, count, max_count) {
    if (count <= 0) {
      return;
    }

    const { officeId , serviceId, } = this.state;
    this.props.router.push(
      '/office/' +  officeId + 
      '/service/' + serviceId + 
      '/interval/' + intervalId
    );
  }

  render() {
    const { daysData, intervalsData, officeData, serviceData, deleteReservationData, mainData, intervalsCommon, previousSteps, logo, sideBarTitles, btnBackTitle, } = this.props; 
    const { selectedDateDay, } = this.props.serviceState;
    const { officeId, serviceId, } = this.state;

    return (
      <div>
        <Header
          logoName={logo.fileName}
          office={officeId}
        />

        <SideBar
          activePage={2}
          officeId={officeId}
          serviceId={serviceId}
          intervalId=''
          titleOne={sideBarTitles.titleOne}
          titleTwo={sideBarTitles.titleTwo}
          titleThree={sideBarTitles.titleThree}
          titleFour={sideBarTitles.titleFour}
        />

        <div className="container-fluid page-header page-sidebar">
        
          <div className="row page-row row-equal">
            <div className="col col-md-6 col-sm-12 page-col">
              <IntervalsContent
                btnBackTitle={btnBackTitle}
                intervalsCommon={intervalsCommon}
                previousSteps={previousSteps}
                daysData={daysData}
                intervalsData={intervalsData}
                officeData={officeData}
                serviceData={serviceData}
                deleteReservationData={deleteReservationData}
                officeId={officeId}
                handleOnClickDay={this.handleOnClickDay}
                selectedDateDay={selectedDateDay}
                onClickTableRow={this.onClickTableRow}
                handleMonthChange={this.handleMonthChange}
              />
            </div>

            {intervalsCommon.showStats &&
              <div className="col col-md-6 col-sm-0 page-col page-col-hide-md page-col-left-border">
                <OfficeStats
                  officeId={officeId}
                  serviceId={serviceId}
                />
              </div>
            }

            {!intervalsCommon.showStats &&
              <div className="col col-md-6 page-col page-col-hide-md page-col-left-border page-col-fixed">
                <Map center={{lat: officeData.data.lat ||  50.075172019694584, lng: officeData.data.lon || 14.450660048824602}} height="100vh">
                  <MouseControl wheel={true} pan={true}/>
                  <CompassControl />
                  <KeyboardControl />
                  <MarkerLayer>
                    <Marker coords={{lat: officeData.data.lat || 0, lng: officeData.data.lon || 0}} />
                  </MarkerLayer>
                </Map>
              </div>
            }

          </div>
        </div>
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  const { daysData, intervalsData, officeData, serviceData, serviceState} = state.intervals;
  const { deleteReservationData } = state.reservation;
  const { year, month, dateChecked, } = state.officeStats;
  const mainData = state.main;

  return { daysData, intervalsData, officeData, serviceData, deleteReservationData, serviceState, mainData,
    officeStats: {
      year,
      month,
      dateChecked,
    },
    intervalsCommon: {
      status: state.main.status,
      ...state.main.data.intervalsCommon,
    },
    btnBackTitle: state.main.data.servicesCommon.title,
    previousSteps: state.main.data.previousSteps,
    logo: {
      ...state.main.data.logo,
    },
    sideBarTitles: {
      titleOne: state.main.data.officesCommon.title,
      titleTwo: state.main.data.servicesCommon.title,
      titleThree: state.main.data.intervalsCommon.title,
      titleFour: state.main.data.reservationCommon.title,
    }
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    getCommonData: bindActionCreators(getCommonData, dispatch),
    getDays: bindActionCreators(getDays, dispatch),
    getIntervals: bindActionCreators(getIntervals, dispatch),
    getOfficeInfo: bindActionCreators(getOfficeInfo, dispatch),
    getServiceInfo: bindActionCreators(getServiceInfo, dispatch),
    serviceSelectDay: bindActionCreators(serviceSelectDay, dispatch),    
    getOfficeStatsYear: bindActionCreators(getOfficeStatsYear, dispatch),    
    getOfficeStatsMonth: bindActionCreators(getOfficeStatsMonth, dispatch),     
    officeSelectDay: bindActionCreators(officeSelectDay, dispatch),  
    officeStatsChangeDate: bindActionCreators(officeStatsChangeDate, dispatch),     
  };
}


export default connect(mapStateToProps, mapDispatchToProps)(IntervalsPage);
 


// WEBPACK FOOTER //
// ./src/pages/Intervals.js